export const HOME_IMPROVEMENT_CREDIT_LINE = 'HOME_IMPROVEMENT_CREDIT_LINE';
export const NONE = 'NONE';
export const PERSONAL_LOAN = 'PERSONAL_LOAN';
export const PERSONAL_CREDIT_LINE = 'PERSONAL_CREDIT_LINE';
export const AUTO_REFINANCE = 'AUTO_REFINANCE';
export const ALL_PRODUCTS = 'ALL_PRODUCTS';
export const REWARDS_CHECKING = 'REWARDS_CHECKING';
export const LENDING_TREE = 'LENDING_TREE';
export const AUTO_FINANCE = 'AUTO_FINANCE';
export const BUY_NOW_PAY_LATER = 'BUY_NOW_PAY_LATER';
//# sourceMappingURL=types.js.map